import {useAgentBuilderStore} from '../AgentBuilder.state';
import {useAgentBuilderNavStore} from '../AgentBuilderNav.state';
import {resetAllFieldDefinitionEditorStores} from '../AiFieldDefinitionEditor.state';

export const useResetAgentBuilder = () => {
  const {reset: resetAgentBuilder} = useAgentBuilderStore();
  const {setStep} = useAgentBuilderNavStore();

  return () => {
    resetAgentBuilder();
    resetAllFieldDefinitionEditorStores();
    setStep('setName');
  };
};
